import React, { Component } from 'react'
import { connect } from 'react-redux';
import {getMinimumOrderQuantityAndNotify} from "../../../utils/minimum-order-quantity-toast";

class OrderingControls extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addPending: false
        };
    }

    addToBasket = () => {
        this.setState({
            addPending: true,
        }, () => {
            const { new_order_page: newOrderPage, product, handleConfirmation, isInBasket, repairedProduct } = this.props;
            const showPopup = (newOrderPage
                && !isInBasket
                && product.attributes.upsell_popup
                && product.attributes.upsell_popup.title);
            let quantity = this.props.quantity;
            // if we try to order with a quantity above the max per order, the basket will automatically update with the max per order quantity so set quantity to this
            if (quantity > this.props.product.attributes.max_per_order && this.props.product.attributes.max_per_order > 0) {
                this.props.setQuantityCounter(this.props.product.attributes.max_per_order);
                quantity = this.props.product.attributes.max_per_order
            }
            quantity = getMinimumOrderQuantityAndNotify(quantity, this.props.product.attributes.minimum_order_quantity)
            // if we try to order with quantity 0 the backend will fail, so set the product quantity to the current quantity in the basket

            if (quantity == 0 && this.props.basket[this.props.product.id]) {
                this.props.setQuantityCounter(this.props.basket[this.props.product.id].product_qty);
                quantity = this.props.basket[this.props.product.id].product_qty
            }

            handleConfirmation(product, quantity, false, isInBasket).then(() => { this.setState({ addPending: false }) });

            if (showPopup) {
                this.props.upsellToggle()
            }
        })

    };

    render() {
        return (
            <div
                onClick={this.addToBasket}
                disabled={this.state.addPending}
                className={this.props.status == 'in-basket' ? 'card-button yellow clickable' : 'card-button green clickable'}
            >
                {this.props.status == 'in-basket' ? 'In Your Basket' : 'Add To Basket'}
            </div>
        )
    }
}

const mapStateToProps = ({ orders: { new: newOrder, new: { basket: { line_items: basket } } } }, ownProps) => {
    const productInBasket = basket[ownProps.product.id]
    const { repairedProduct } = newOrder

    return {
        basket,
        productInBasket,
        product_qty: productInBasket ? productInBasket.product_qty : 0,
        isInBasket: !!productInBasket,
        repairedProduct,
    }
};

export default connect(mapStateToProps)(OrderingControls);



// WEBPACK FOOTER //
// ./src/components/new-order/card/ordering-controls.jsx